module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/icon_arrow_down-8cbec204f8ad09de0af8bda6988dfb22.svg";